import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const INTEREST_STATUSES = {
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not_interested'
};

const state = {
  markInterestDone: false,
  noInterestMarksLeft: false,
  // Byteslistan 3.0: the last successful interest mark { propositionId, interested },
  // so the swap list can dismiss a card answered from the proposition detail page.
  lastMarked: null,
  // Ids the user has superliked this session (as strings). In-memory only:
  // no endpoint exposes superlike status yet, so it is lost on reload.
  superLikedIds: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
